import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { featuredMovies } from '@/mocks/movies';

export default function HeroSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const current = featuredMovies[currentIndex];

  const goTo = useCallback((index: number) => {
    setCurrentIndex(index);
  }, []);

  const goNext = useCallback(() => {
    setCurrentIndex((prev) => (prev + 1) % featuredMovies.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(goNext, 5000);
    return () => clearInterval(timer);
  }, [goNext]);

  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center transition-all duration-700 ease-in-out"
        style={{ backgroundImage: `url(${current.image})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-background-950"></div>
      </div>

      <div className="relative z-10 h-full max-w-[1400px] mx-auto px-4 md:px-6 flex items-end pb-14 md:pb-20">
        <div className="w-full flex flex-col md:flex-row items-start md:items-end gap-8">
          <div className="flex-1 max-w-2xl">
            <div className="flex items-center gap-2 mb-3 flex-wrap">
              {current.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-2.5 py-0.5 text-xs font-medium rounded-full bg-primary-500/90 text-white whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
              <span className="text-xs text-white/60">{current.category}</span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-3 tracking-wide">
              {current.title}
            </h2>
            <p className="text-sm md:text-base text-white/70 mb-5 line-clamp-2 max-w-lg">
              {current.description}
            </p>
            <div className="flex items-center gap-3">
              <Link
                to={`/article/${current.id}`}
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观看
              </Link>
              <span className="text-sm text-white/60">
                <i className="ri-star-fill text-yellow-400 mr-1"></i>
                {current.rating}
              </span>
              <span className="text-xs text-white/50">{current.updateInfo}</span>
            </div>
          </div>

          <div className="flex gap-2 md:gap-3">
            {featuredMovies.map((movie, index) => (
              <button
                key={movie.id}
                onClick={() => goTo(index)}
                className={`w-2.5 h-2.5 md:w-3 md:h-3 rounded-full transition-all duration-300 cursor-pointer ${
                  index === currentIndex
                    ? 'bg-primary-500 w-7 md:w-8'
                    : 'bg-white/40 hover:bg-white/70'
                }`}
                aria-label={`切换到${movie.title}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}